var exports = {
  "k4": "prHeader__O574tV",
  "_0": "is-stuck__uluY_6",
  "mF": "prTitleArea__NVcoMm",
  "ql": "stickyHeaderActivationThreshold__WEJcTE",
  "L9": "textEllipsis__9QEHDs",
  "yF": "divider__Kjz0MY",
};

module.exports = exports;
